<template>
  <div>
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/admin/trilha'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de cursos da trilha"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-8 col-md-10">
            <p class="text-white my-3">
              Aqui você pode conferir os materiais cadastrados em cada uma das
              seções do curso <b>{{ courseTitle }}</b
              >. Todo novo material cadastrado será exibido na listagem abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-12">
          <materiais-list @courseTitle="courseTitle = $event" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MateriaisList from "./Materiais/MateriaisList";

export default {
  name: "admin-trilha-materiais",
  components: {
    MateriaisList,
  },
  data() {
    return {
      courseTitle: "",
    };
  },
};
</script>
